import React, {  useRef, useEffect, useContext, } from 'react'
import Editor from '../Components/Editor'
import { initSocket } from '../socketInit'
import ACTIONS from '../Components/Actions'
import toast from 'react-hot-toast'
import { useLocation, useParams, useNavigate, Navigate } from 'react-router-dom';
import Output from '../Components/Output'
import runContext from '../Context/RunContext'
import Chatspace from '../Components/Chatspace'
import ChatContext from '../Context/ChatContext'
import LoadContext from '../Context/LoadContext'



export default function EditorPage() {
  const socketRef = useRef(null);
  const codeRef = useRef(null)
  const location = useLocation();
  const { roomId } = useParams();
  const reactNavigator = useNavigate();

  const { SetClients} = useContext(runContext);
  const {sendMessage} = useContext(ChatContext);
  const {setLoading} = useContext(LoadContext)
  // handle errors
  function handleErrors(err){
    reactNavigator("/");
    toast.error(err);
  }
  useEffect(() => {
    
    const init = async () => {
      socketRef.current = await initSocket();
      socketRef.current.on('connect_error', (err) => {
        handleErrors(err);
      });
      socketRef.current.on('connect_failed', (err) => handleErrors(err));
      socketRef.current.emit(ACTIONS.JOIN, {
        roomId,
        username: location.state?.username
      });


      // listening to JOINED
      socketRef.current.on(
        ACTIONS.JOINED,
        ({ clients, username, socketId }) => {
            if (username !== location.state?.username) {
                toast.success(`${username} joined the room.`);
                sendMessage(socketRef.current,username,roomId,`${username} joined the chat!!`)
            }
            
            SetClients(clients);
            socketRef.current.emit(ACTIONS.SYNC_CODE, {
                code: codeRef.current,
                socketId,
            });
            // socketRef.current.emit(ACTIONS.SYNC_MESSAGE, {
            //     socketId,
            // });

        }
    );
      //listening for disconnecting
      socketRef.current.on(ACTIONS.DISCONNECTED, ({ socketId, username, clients }) => {
        toast.success(`${username} left the meet`);
        sendMessage(socketRef.current,username,roomId,`${username} left the chat!!`)
        SetClients((prev) => {
          return prev.filter((client) => client.socketId !== socketId)
        })

      })
    }
    init();
    return () => {
      socketRef.current.disconnect();
      socketRef.current.off(ACTIONS.JOINED);
      socketRef.current.off(ACTIONS.DISCONNECTED);
    }
  }
  // eslint-disable-next-line
  , []);

  // useEffect(()=>{
  //   setLoading(true)
  //   return ()=>{
  //     setLoading(false)
  //   }
  // },[])
  return (
    <>
      {location.state===null ? <Navigate to="/" state="true"/> :<div className='main-eWindow'>
        <Editor socketRef={socketRef} roomId={roomId} onCodeChange={(code) => {
          codeRef.current = code;
        }} />
        <div className='out-chat'>
        <Output/>
        <Chatspace socketRef={socketRef} roomId={roomId} username={location.state.username}/>
        </div>
        
      </div>}
    </>
  )
}
